// MobileBanner.js
import React, { useState,useEffect  } from 'react';
import '../assets/style/MobileBanner.css';
import icon from '../assets/images/app-icon.png'
import appleStore from '../assets/images/apple-store.png'; // تصویر Apple Store
import googlePlay from '../assets/images/google-play.png'; // تصویر Google Play

const MobileBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const handleInstallClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleScroll = (e) => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // console.log('Scroll Top:', scrollTop);

    
    if (scrollTop > 100) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    document.body.addEventListener('scroll', handleScroll)
    return () => document.body.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div>
      <div className={`mobile-banner ${scrolling ? 'mobile-banner-fixed' : 'mobile-banner-sticky'}`}>
        <div className="banner-content">
          <img src={icon} alt="App Icon" className="banner-icon" />
          <span className="banner-text">DaytoDay Mobile Application</span>
       
        </div>
        <button className="install-button" onClick={handleInstallClick}>Install</button>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="install-modal" onClick={(e) => e.stopPropagation()}>

            <div className="modal-headers">
              <div className='modal-title'>
              
                <h2>DaytoDay Application</h2>
                <p>Experience a better shopping</p>
              </div>
              <div className="modal-button">
                {/* <img src={closeIcon} alt="Close" className="close-button" onClick={closeModal} /> */}
                <div className="close-button" onClick={closeModal}>
                  <i className='bi--close'></i>
                </div>
              </div>
            </div>
            <div className="modal-contents">

              <div className="store-buttons">
                <a href="https://apps.apple.com/ae/app/day-to-day-online/id6504225370" target="_blank" rel="noopener noreferrer">
                  <img src={appleStore} alt="Apple Store" className="store-button" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.daytodayonline" target="_blank" rel="noopener noreferrer">
                  <img src={googlePlay} alt="Google Play" className="store-button" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileBanner;